import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- NATIVE SERVICE WORKER REGISTRATION WITH UPDATE DETECTOR ---
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then((registration) => {
//         console.log('ServiceWorker registration successful');
//
//         // SCENARIO 1: An update downloaded on a previous session and is already waiting
//         if (registration.waiting) {
//           window.dispatchEvent(new CustomEvent('pwa-update-available', { detail: registration.waiting }));
//         }
//
//         // SCENARIO 2: An update is found while the user actively has the application open
//         registration.onupdatefound = () => {
//           const installingWorker = registration.installing;
//           if (installingWorker) {
//             installingWorker.onstatechange = () => {
//               // Check if the download phase has completed entirely
//               if (installingWorker.state === 'installed') {
//                 if (navigator.serviceWorker.controller) {
//                   // The new worker is fully cached and waiting to take control
//                   window.dispatchEvent(new CustomEvent('pwa-update-available', { detail: registration.waiting || installingWorker }));
//                 }
//               }
//             };
//           }
//         };
//       })
//       .catch((err) => {
//         console.error('ServiceWorker registration failed: ', err);
//       });
//   });
// }

reportWebVitals();
